import type { IWhereUsedSectionTab } from '~/components/pages/directions/where-used-section/where-used-section.types'

const WHERE_USED_RADIOGUIDE: IWhereUsedSectionTab[] = [
    {
        title: 'На производстве',
        image: '/assets/images/usage/radioguide/jpg-png/builders.png',
        image_webp: '/assets/images/usage/radioguide/webp/builders.webp',
        text: `
            <p>Радиогиды позволяют проводить экскурсии и&nbsp;лекции на&nbsp;заводе, фабрике или в&nbsp;любом самом шумном цеху благодаря функции шумоподавления и&nbsp;усиления голоса.</p>
            <p>Наши экскурсионные радиосистемы часто используют не&nbsp;только для потенциальных клиентов производственных компаний, но&nbsp;и&nbsp;для новых сотрудников, которым необходимо пройти обучение в&nbsp;условиях повышенного шума.</p>
            <br/>
            <p>Полезные функции радиогидов Reinvox для экскурсий на&nbsp;производстве:</p>
            <ul>
                <li>любое количество слушателей</li>
                <li>дистанция приема сигнала до&nbsp;200 метров</li>
                <li>отсутствие паразитных наводок от&nbsp;оборудования</li>
            </ul>
            `,
    },
    {
        title: 'Пешие экскурсии',
        image: '/assets/images/usage/radioguide/jpg-png/museum.png',
        image_webp: '/assets/images/usage/radioguide/webp/museum.webp',
        text: `
            <p>На&nbsp;уличной экскурсии радиогид Reinvox позволяет слушателям отойти от&nbsp;гида на&nbsp;расстояние до&nbsp;200 метров и&nbsp;самостоятельно осмотреть тот или иной экспонат или точку интереса. При этом голос гида в&nbsp;наушнике звучит громко и&nbsp;чётко, словно он&nbsp;находится на&nbsp;расстоянии вытянутой руки.</p>
            <br/>
            <p>Полезные функции радиосистемы Reinvox для экскурсий на&nbsp;улице:</p>
            <ul>
                <li>количество слушателей в&nbsp;группе не&nbsp;ограничено</li>
                <li>можно отходить на&nbsp;расстояние до&nbsp;200 метров</li>
                <li>быстрая и&nbsp;понятная настройка техники сэкономит время на&nbsp;обучении туристов</li>
                <li>Радиогиды берегут голос гида и&nbsp;помогает держать безопасную дистанцию</li>
            </ul>
            `,
    },
    {
        title: 'Музеи и выставки',
        image: '/assets/images/usage/radioguide/jpg-png/in-museum.png',
        image_webp: '/assets/images/usage/radioguide/webp/in-museum.webp',
        text: `
            <p>Многоканальность радиогидов Reinvox позволяет в&nbsp;одном музее или даже в&nbsp;одном зале проводить экскурсии разным группам посетителей, при этом не&nbsp;мешая друг другу.</p>
            <p>Благодаря высокочувствительному головному микрофону, экскурсовод может говорить почти шепотом, и&nbsp;его голос будет отчетливо слышен в&nbsp;персональных наушниках.</p>
            <br/>
            <p>Полезные функции радиосистемы Reinvox для музеев и&nbsp;выставок:</p>
            <ul>
                <li>много групп в&nbsp;одном зале</li>
                <li>количество слушателей в&nbsp;группе не&nbsp;ограничено</li>
                <li>высокочувствительный микрофон экскурсовода</li>
                <li>сигнал проходит через стены и&nbsp;позволяет слушателю задержаться в&nbsp;предыдущем зале</li>
            </ul>
            `,
    },
    {
        title: 'Речные круизы',
        image: '/assets/images/usage/radioguide/jpg-png/boat-group-tour.jpg',
        image_webp: '/assets/images/usage/radioguide/webp/boat-group-tour.webp',
        text: `
            <p>Шум ветра на&nbsp;воде и&nbsp;гул двигателя больше не&nbsp;будут проблемой благодаря экскурсионной радиосистеме Reinvox.</p>
            <p>Посетители могут отходить на&nbsp;другой конец судна или в&nbsp;трюм, при этом полноценно слушая экскурсию.</p>
            <br/>
            <p>Полезные функции радиосистемы Reinvox для водных экскурсий:</p>
            <ul>
                <li>много групп в&nbsp;одном зале</li>
                <li>количество слушателей в&nbsp;группе не&nbsp;ограничено</li>
                <li>высокочувствительный микрофон экскурсовода</li>
                <li>отсутствие паразитных наводок от&nbsp;оборудования судна</li>
            </ul>
            `,
    },
    {
        title: 'Мобильный перевод',
        image: '/assets/images/usage/radioguide/jpg-png/scientists.png',
        image_webp: '/assets/images/usage/radioguide/webp/scientists.webp',
        text: `
            <p>Когда при проведении мероприятий с&nbsp;участием иностранных гостей нет возможности использовать полноценную изолированную кабину и&nbsp;пульт переводчиков, синхронный перевод можно обеспечить с&nbsp;помощью передатчика с&nbsp;микрофоном (для переводчика) и&nbsp;приемников для слушателей.</p>
            <p>Так&nbsp;же радиогиды можно использовать при персональном переводе на&nbsp;ходу, располагая переводчика на&nbsp;небольшой дистанции от&nbsp;говорящих.</p>
            <p>А&nbsp;если добавить второй передатчик для говорящего и&nbsp;приемник для переводчика, то&nbsp;и&nbsp;вовсе получится находиться синхронисту на&nbsp;расстоянии до&nbsp;200&nbsp;метров.</p>
            `,
    },
    {
        title: 'Образование',
        image: '/assets/images/usage/radioguide/jpg-png/teacher.png',
        image_webp: '/assets/images/usage/radioguide/webp/teacher.webp',
        text: `
            <p>Беспроводная радиосистема подходит для спортивных школ, внеклассных уроков, школьных экскурсий, детских и&nbsp;студенческих мероприятий.</p>
            <p>Например, поможет преподавателю на&nbsp;мастер-классе комментировать действия учеников и&nbsp;давать рекомендации.</p>
            <p>Чувствительный микрофон радиогида позволит преподавателю не&nbsp;напрягать голосовые связки, а&nbsp;неограниченное число приемников позволит собрать аудиторию любого размера.</p>
            `,
    },
    {
        title: 'Конференции',
        image: '/assets/images/usage/radioguide/jpg-png/conference.png',
        image_webp: '/assets/images/usage/radioguide/webp/conference.webp',
        text: `
            <p>Вместо классических колонок и&nbsp;микрофонов можно использовать радиогиды с&nbsp;персональными наушниками. Позволяет удобно перемещаться, общаться с&nbsp;коллегами и&nbsp;слушать докладчиков из&nbsp;любой части зала. Так&nbsp;же, можно использовать комбинацию из&nbsp;микрофонов в&nbsp;зале, но&nbsp;звук вместо колонок распространять по&nbsp;беспроводному каналу, подключив передатчик к&nbsp;выходу микшерного пульта. Это позволит полностью исключить эффект акустической обратной связи, которая выражается в&nbsp;виде свиста и&nbsp;гула.</p>
            `,
    },
]

export default WHERE_USED_RADIOGUIDE
